//initial redux
import { put, call, takeEvery, all, select } from "redux-saga/effects";
import moment from "moment-timezone";
import rulesservice from "../../services/rules";
import { delay } from "redux-saga";

const initialState = {
   addCommentOpen: false,
   listCommentsOpen: false,
   addCommentViaChartOpen: false,
   addCommentViaGenericOpen: false,
   chartCommentOpen: false,
   genericCommentOpen: false,
   deleteConfirmOpen: false,

   commentUpdate: 0,

   errors: [],
   commentList: [],

   isChartOn: false,
   wasChartClicked: false,
};

/////////
//types
export const types = {
   LOAD_CHART: "components/chartcomment/LOAD_CHART",
   ON_LOAD_CHART: "components/chartcomment/ON_LOAD_CHART",
   RESET_CHARTS: "components/chartcomment/RESET_CHARTS",
	CHART_CLICKING_ON: "components/chartcomment/CHART_CLICKING_ON",
	CHART_CLICKING_OFF: "components/chartcomment/CHART_CLICKING_OFF",
   CHART_CLICKED: "components/chartcomment/CHART_CLICKED",
   SET_CHART_CLICK_VALUES: "components/chartcomment/SET_CHART_CLICK_VALUES",

   ADD_COMMENT_OPEN: "components/chartcomment/ADD_COMMENT_OPEN",
   ADD_COMMENT_CLOSE: "components/chartcomment/ADD_COMMENT_CLOSE",
   LIST_COMMENTS_OPEN: "components/chartcomment/LIST_COMMENTS_OPEN",
   LIST_COMMENTS_CLOSE: "components/chartcomment/LIST_COMMENTS_CLOSE",
   ADD_COMMENT_VIA_CHART_CLICK: "components/chartcomment/ADD_COMMENT_VIA_CHART_CLICK",
   ADD_COMMENT_VIA_CHART_CLOSE: "components/chartcomment/ADD_COMMENT_VIA_CHART_CLOSE",
   ADD_COMMENT_VIA_GENERIC_CLICK: "components/chartcomment/ADD_COMMENT_VIA_GENERIC_CLICK",
   ADD_COMMENT_VIA_GENERIC_CLOSE: "components/chartcomment/ADD_COMMENT_VIA_GENERIC_CLOSE",
   GENERIC_COMMENT_OPEN: "components/chartcomment/GENERIC_COMMENT_OPEN",
   GENERIC_COMMENT_CLOSE: "components/chartcomment/GENERIC_COMMENT_CLOSE",
   CHART_COMMENT_OPEN: "components/chartcomment/CHART_COMMENT_OPEN",
   CHART_COMMENT_CLOSE: "components/chartcomment/CHART_COMMENT_CLOSE",
   
   SAVE_CHART_COMMENT: "components/chartcomment/SAVE_CHART_COMMENT",
   ON_SAVE_CHART_COMMENT: "components/chartcomment/ON_SAVE_CHART_COMMENT",
   SAVE_GENERIC_COMMENT: "components/chartcomment/SAVE_GENERIC_COMMENT",
   ON_SAVE_GENERIC_COMMENT: "components/chartcomment/ON_SAVE_GENERIC_COMMENT",

   GET_COMMENT_LIST: "components/chartcomment/GET_COMMENT_LIST",
   ON_GET_COMMENT_LIST: "components/chartcomment/ON_GET_COMMENT_LIST",

   SET_DELETE_COMMENT: "components/chartcomment/SET_DELETE_COMMENT",
   DELETE_COMMENT: "components/chartcomment/DELETE_COMMENT",
   DELETE_CONFIRM_OPEN: "components/chartcomment/DELETE_CONFIRM_OPEN",
   DELETE_CONFIRM_CLOSE: "components/chartcomment/DELETE_CONFIRM_CLOSE",

   INCREMENT_COMMENT_UPDATE: "components/chartcomment/INCREMENT_COMMENT_UPDATE",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
         case types.INCREMENT_COMMENT_UPDATE: {
            return { ...state, commentUpdate: (state.commentUpdate + 1) };
         }
         case types.ON_GET_COMMENT_LIST: {
            return { ...state, commentList: action.payload };
         }
         case types.ADD_COMMENT_OPEN: {
            return { ...state, addCommentOpen: true };
         }
         case types.ADD_COMMENT_CLOSE: {
            return { ...state, addCommentOpen: false };
         }
         case types.LIST_COMMENTS_OPEN: {
            return { ...state, listCommentsOpen: true };
         }
         case types.LIST_COMMENTS_CLOSE: {
            return { ...state, listCommentsOpen: false };
         }
         case types.CHART_COMMENT_OPEN: {
            return { ...state, chartCommentOpen: true };
         }
         case types.CHART_COMMENT_CLOSE: {
            return { ...state, chartCommentOpen: false };
         }
         case types.GENERIC_COMMENT_OPEN: {
            return { ...state, genericCommentOpen: true };
         }
         case types.GENERIC_COMMENT_CLOSE: {
            return { ...state, genericCommentOpen: false };
         }
         case types.DELETE_CONFIRM_OPEN: {
            return { ...state, deleteConfirmOpen: true };
         }
         case types.DELETE_CONFIRM_CLOSE: {
            return { ...state, deleteConfirmOpen: false, commentToDeleteId: undefined };
         }
         case types.ADD_COMMENT_VIA_CHART_CLICK: {
            return { ...state, addCommentOpen: false, isChartOn: true, genericCommentOpen: false }
         }
         case types.ADD_COMMENT_VIA_CHART_CLOSE: {
            return { ...state, chartCommentOpen: false };
         }
         case types.ADD_COMMENT_VIA_GENERIC_CLICK: {
            return { ...state, addCommentOpen: false, isChartOn: false, genericCommentOpen: true }
         }
         case types.ADD_COMMENT_VIA_GENERIC_CLOSE: {
            return { ...state, genericCommentOpen: false }
         }
			case types.CHART_CLICKING_ON: {
				return { ...state, isChartOn: true };
         }
         case types.CHART_CLICKING_OFF: {
            return { ...state, isChartOn: false };
         }
         case types.SET_CHART_CLICK_VALUES: {
            return { ...state, xVal: action.payload.x, yVal: action.payload.y, isChartOn: false, chartCommentOpen: true, genericCommentOpen: false };
         }
         case types.ON_SAVE_CHART_COMMENT: {
            return { ...state, chartCommentOpen: false }
         }
         case types.ON_SAVE_GENERIC_COMMENT: {
            return { ...state, genericCommentOpen: false }
         }
         case types.SET_DELETE_COMMENT: {
            return { ...state, commentToDeleteId: action.payload.reportCommentId }
         }
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
         this.chartClicked(),
         this.saveChartComment(),
         this.saveGenericComment(),
         this.onGetCommentList(),
         this.onSetDeleteComment(),
         this.onDeleteComment()
      ]);
	},

   *onDeleteComment() {
      yield takeEvery(types.DELETE_COMMENT, function*({ payload }) {
         let chartcomment = yield select(x => x.chartcomment);
         yield call(rulesservice.DeleteComment, chartcomment.commentToDeleteId);
         yield put(actions.deleteConfirmClose());

         yield put(actions.getCommentList(payload.ruleInstanceId, payload.from, payload.to));
         yield put(actions.incrementCommentUpdate());
      });
   },
   *onSetDeleteComment() {
      yield takeEvery(types.SET_DELETE_COMMENT, function*({ payload }) {
         yield put(actions.deleteConfirmOpen());
      });
   },
   *onGetCommentList() {
      yield takeEvery(types.GET_COMMENT_LIST, function*({ payload }) {
         if(!payload.ruleInstanceId) {
            return;
         }
         const from = moment(payload.from).add(moment().utcOffset(), "minutes");
         const to = moment(payload.to).add(moment().utcOffset(), "minutes");
         
         let list = yield call(rulesservice.GetReportComments, payload.ruleInstanceId, from, to);

         if(list instanceof Array) {
            yield put(actions.onGetCommentList(list));
            yield put(actions.incrementCommentUpdate());
         }
      });
   },
	*chartClicked() {
		yield takeEvery(types.CHART_CLICKED, function*({ payload }) {
         const chartcomment = yield select(x => x.chartcomment);

         if(!chartcomment.isChartOn) {
            return;
         }

         yield put(actions.setChartClickValues(payload.x, payload.y));
      });
   },
   *saveChartComment() {
      yield takeEvery(types.SAVE_CHART_COMMENT, function*({ payload }) {
         const chartcomment = yield select(x => x.chartcomment);
         const from = moment(payload.from).add(moment().utcOffset(), "minutes");
         const to = moment(payload.to).add(moment().utcOffset(), "minutes");

         yield call(rulesservice.CreateReportComment, payload.ruleInstanceId, payload.description, chartcomment.yVal, chartcomment.xVal, false);
         yield put(actions.onSaveChartComment());

         yield delay(1000);

         yield put(actions.getCommentList(payload.ruleInstanceId, payload.from, payload.from));
         yield put(actions.incrementCommentUpdate());
      });
   },
   *saveGenericComment() {
      yield takeEvery(types.SAVE_GENERIC_COMMENT, function*({ payload }) {
         const from = moment(payload.from).add(moment().utcOffset(), "minutes");
         const to = moment(payload.to).add(moment().utcOffset(), "minutes");

         yield call(rulesservice.CreateReportComment, payload.ruleInstanceId, payload.description, null, from, to, true);
         yield put(actions.onSaveGenericComment());

         yield delay(1000);
         
         yield put(actions.getCommentList(payload.ruleInstanceId, payload.from, payload.from));
         yield put(actions.incrementCommentUpdate());
      });
   }
};

////////
//actions
export const actions = {
	chartClickingOn() {
		return {
			type: types.CHART_CLICKING_ON,
		};
   },
   chartClickingOff() {
      return {
         type: types.CHART_CLICKING_OFF,
      };
   },
   chartClicked(x, y) {
      return {
         type: types.CHART_CLICKED,
         payload: {x, y}
      }
   },
   loadChart(chart) {
      return {
         type: types.LOAD_CHART,
         payload: chart,
      };
   },
   resetCharts() {
      return {
         type: types.RESET_CHARTS,
      };
   },
   setChartClickValues(x, y) {
      return {
         type: types.SET_CHART_CLICK_VALUES,
         payload: {x, y}
      };
   },
   addCommentClick() {
      return {
         type: types.ADD_COMMENT_OPEN,
      };
   },
   listCommentsClick() {
      return {
         type: types.LIST_COMMENTS_OPEN,
      };
   },
   addCommentViaChartClick() {
      return {
         type: types.ADD_COMMENT_VIA_CHART_CLICK,
      };
   },
   addCommentViaGenericClick() {
      return {
         type: types.ADD_COMMENT_VIA_GENERIC_CLICK,
      };
   },
   addCommentClose() {
      return {
         type: types.ADD_COMMENT_CLOSE,
      };
   },
   listCommentsClose() {
      return {
         type: types.LIST_COMMENTS_CLOSE,
      };
   },
   addCommentViaChartClose() {
      return {
         type: types.ADD_COMMENT_VIA_CHART_CLOSE,
      };
   },
   addCommentViaGenericClose() {
      return {
         type: types.ADD_COMMENT_VIA_GENERIC_CLOSE,
      };
   },
   saveChartComment(ruleInstanceId, description, from, to) {
      return {
         type: types.SAVE_CHART_COMMENT,
         payload: { ruleInstanceId, description, from, to },
      };
   },
   onSaveChartComment() {
      return {
         type: types.ON_SAVE_CHART_COMMENT
      };
   },
   saveGenericComment(ruleInstanceId, description, from, to) {
      return {
         type: types.SAVE_GENERIC_COMMENT,
         payload: { ruleInstanceId, description, from, to },
      };
   },
   onSaveGenericComment() {
      return {
         type: types.ON_SAVE_GENERIC_COMMENT,
      };
   },
   getCommentList(ruleInstanceId, from, to) {
      return {
         type: types.GET_COMMENT_LIST,
         payload: { ruleInstanceId, from, to}
      };
   },
   onGetCommentList(list) {
      return {
         type: types.ON_GET_COMMENT_LIST,
         payload: list
      };
   },
   setDeletingComment(comment) {
      return {
         type: types.SET_DELETE_COMMENT,
         payload: comment
      }
   },
   deleteComment(ruleInstanceId, from, to) {
      return {
         type: types.DELETE_COMMENT,
         payload: { ruleInstanceId, from, to}
      }
   },
   deleteConfirmOpen() {
      return {
         type: types.DELETE_CONFIRM_OPEN
      }
   },
   deleteConfirmClose() {
      return {
         type: types.DELETE_CONFIRM_CLOSE
      }
   },
   incrementCommentUpdate() {
      return {
         type: types.INCREMENT_COMMENT_UPDATE
      }
   }
};



// WEBPACK FOOTER //
// ./src/components/ChartComment/redux.js